import { render, staticRenderFns } from "./YnLogin.vue?vue&type=template&id=b4cf43fc&scoped=true&"
import script from "./YnLogin.vue?vue&type=script&lang=js&"
export * from "./YnLogin.vue?vue&type=script&lang=js&"
import style0 from "./YnLogin.vue?vue&type=style&index=0&id=b4cf43fc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4cf43fc",
  null
  
)

export default component.exports